export default "__VITE_PUBLIC_ASSET__feff3c1e__"